//  Applica personalizzazioni di frontend (logo, stili custom)
import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import cssVars from 'css-vars-ponyfill'

import PersonalizationAPI from '../../../api/personalization/PersonalizationAPI'

class Personalization extends Component {
  constructor (props) {
    super()
    //
    this.mounted = false
    //
    this.settings = {}
    //
    this.state = {
      showMainContent: false
    }
  }

  componentDidMount () {
    this.mounted = true
    //

    //
    if (this.props.showLogo || this.props.applyCustomCSS) {
      this.getListSettings().then(() => {
        if (this.mounted) {
          //
          this.applyCustomCSS()
          //
          this.setState({
            showMainContent: true
          })
        }
      })
    }
  }

  componentWillUnmount () {
    this.mounted = false
  }

  getListSettings () {
    return PersonalizationAPI.getListSettings(this.props.idList).then((settings) => {
      this.settings = settings
    })
  }

  applyCustomCSS () {
    if (this.props.applyCustomCSS && this.settings.Style) {
      const customCSS = JSON.parse(this.settings.Style)
      const fontProperties = ['--paragraphs-fonturl', '--titles-fonturl']
      //
      const properties = this.fixValues(this.toKeyValue('-', customCSS))

      //  Aggiunta font
      fontProperties.forEach((key) => {
        if (properties.hasOwnProperty(key)) {
          if (!document.querySelector('link[href="' + properties[key] + '"]')) {
            //
            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.href = properties[key]
            document.head.appendChild(link)
          }
        }
      })

      //
      Object.keys(properties).forEach((key) => {
        document.documentElement.style.setProperty(key, properties[key])
      })
      //  polyfill
      cssVars({
        variables: properties
      })
    }
  }

  toKeyValue (prevkey, o, separator = '-') {
    let result = {}
    for (const k in o) {
      let newkey = k
      if (prevkey) {
        newkey = prevkey.toLowerCase() + separator + k.toLowerCase()
      }

      if (o.hasOwnProperty(k)) {
        const p = o[k]

        if (typeof p === 'object') {
          result = Object.assign(result, this.toKeyValue(newkey, p))
        } else {
          result[newkey] = p
        }
      }
    }
    return result
  }

  /**
   * Corregge variabili senza 'px' aggiungendo unità di misura
   * Crea variabili per colori da esprimere in rgb
   */
  fixValues (properties) {
    const missingPx = ['--paragraphs-fontsize', '--titles-fontsize']
    const numberOnlyRegEx = /^[0-9]+$/
    //
    const colorsToSplit = ['--paragraphs-color', '--link-color', '--social-backgroud']
    const colorRegEx = /^#[0-9a-fA-F]{6}$/
    const colorShortRegEx = /^#[0-9a-fA-F]{3}$/
    //
    missingPx.forEach((key) => {
      if (properties.hasOwnProperty(key) && numberOnlyRegEx.test(properties[key])) {
        properties[key] = properties[key] + 'px'
      }
    })
    //
    colorsToSplit.forEach((key) => {
      if (properties.hasOwnProperty(key)) {
        //  gestione alpha channel
        if (properties[key] == 'transparent') {
          properties[key + '-A'] = '0'
        } else {
          properties[key + '-A'] = '1'
        }
        //
        if (colorShortRegEx.test(properties[key])) {
          properties[key + '-R'] = parseInt('' + properties[key].substring(1, 2) + properties[key].substring(1, 2), 16)
          properties[key + '-G'] = parseInt('' + properties[key].substring(2, 3) + properties[key].substring(2, 3), 16)
          properties[key + '-B'] = parseInt('' + properties[key].substring(3, 4) + properties[key].substring(3, 4), 16)
        } else if (colorRegEx.test(properties[key])) {
          properties[key + '-R'] = parseInt('' + properties[key].substring(1, 3), 16)
          properties[key + '-G'] = parseInt('' + properties[key].substring(3, 5), 16)
          properties[key + '-B'] = parseInt('' + properties[key].substring(5, 7), 16)
        }
      }
    })
    //
    return properties
  }

  render () {
    if (!this.props.showLogo) {
      return null
    }
    //  se non si hanno nè CompanyLogo nè CompanyName non creare alcun elemento in DOM
    if (!this.settings.CompanyLogo && !this.settings.CompanyName) {
      return null
    }

    return (
      <>
        {this.state.showMainContent &&

          <div className='frontend-wrapper personalization-logo'>
            {this.settings.CompanyLogo &&
              <>
                {this.settings.CompanyURL &&
                  <a href={this.settings.CompanyURL} target='_blank' rel='noopener noreferrer'><img src={this.settings.CompanyLogo} /></a>}
                {!this.settings.CompanyURL &&
                  <p className='logo-wrapper'><img src={this.settings.CompanyLogo} /></p>}
              </>}

            {!this.settings.CompanyLogo && this.settings.CompanyName &&
              <>
                {this.settings.CompanyURL &&
                  <h1><a href={this.settings.CompanyURL} target='_blank' rel='noopener noreferrer'>{this.settings.CompanyName}</a></h1>}
                {!this.settings.CompanyURL &&
                  <h1>{this.settings.CompanyName}</h1>}
              </>}
          </div>}
      </>
    )
  }
}

Personalization.defaultProps = {
  showLogo: false,
  applyCustomCSS: false
}

Personalization.propTypes = {
  // idList: PropTypes.string.isRequired,
  showLogo: PropTypes.bool,
  applyCustomCSS: PropTypes.bool
}

export default Personalization
